import styled from 'styled-components';

const EdgeLine = styled.line``;

export { EdgeLine };